import './story-slider.scss';
import Swiper from 'swiper/bundle';

export default () => {
	new Swiper('.js-story-swiper', {
		slidesPerView: 1.1,
//    	centeredSlides: true,
//		freeMode: true,
		spaceBetween: 20,
		loop: true,
		navigation: {
			prevEl: ".story-prev",
			nextEl: ".story-next",
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 30,
			},

			1440: {
				slidesPerView: 2,
				spaceBetween: 108,
			}
		}
	});

};
